import { z } from "zod";
import { PandadocDocumentHistoryField } from "@remi/enums/pandadoc-document/history/field";
import { PandadocDocumentStatusSchema } from "@remi/enums/pandadoc-document-status";

export const PandadocDocumentHistorySchema = z
  .object({
    id: z.string(),
    documentId: z.string(),
    changedById: z.string(),
    createdAt: z.coerce.date(),
  })
  .and(
    z.discriminatedUnion("field", [
      z.object({
        field: z.literal(PandadocDocumentHistoryField.status),
        changedTo: PandadocDocumentStatusSchema,
        changedFrom: PandadocDocumentStatusSchema.nullable(),
      }),
      z.object({
        field: z.literal(PandadocDocumentHistoryField.sentAt),
        changedTo: z.coerce.date().nullable(),
        changedFrom: z.coerce.date().nullable(),
      }),
      z.object({
        field: z.literal(PandadocDocumentHistoryField.lastViewedAt),
        changedTo: z.coerce.date().nullable(),
        changedFrom: z.coerce.date().nullable(),
      }),
    ]),
  );

export type PandadocDocumentHistory = z.infer<typeof PandadocDocumentHistorySchema>;
